import { useEffect } from 'react';

export const useHeaderTopOffset = (open: boolean, offset = 0) => {
	useEffect(() => {
		if (!open) return;
		let animationFrameId = 0;

		const updateHeaderTop = () => {
			const topEl = document.getElementById('header-top');
			const bottomEl = document.getElementById('header-bottom');
			const topY = topEl ? Math.max(topEl.getBoundingClientRect().top, 0) : 0;
			const bottomY = bottomEl ? Math.max(bottomEl.getBoundingClientRect().top, 0) : 66;
			const headerSize = Math.max(bottomY - topY, 0);
			document.documentElement.style.setProperty('--mini-cart-top', `${headerSize - offset}px`);
			animationFrameId = window.requestAnimationFrame(updateHeaderTop);
		};

		animationFrameId = window.requestAnimationFrame(updateHeaderTop);

		return () => window.cancelAnimationFrame(animationFrameId);
	}, [open, offset]);
};
